/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

const PAGINATION = {
  VISUALS_PER_PAGE_COUNT: 500,
  VISUAL_FILTERS_PER_PAGE_COUNT: 200,
  MAJOR_EVENT_CATEGORIES_PER_PAGE: 200,
  MINOR_EVENT_CATEGORIES_PER_PAGE: 200,
  HOTELS_PER_PAGE_COUNT: 1500,
  USERS_PER_PAGE_COUNT: 2000,
  USER_INVITES_PER_PAGE_COUNT: 200,
  AUDIT_LOGS_PER_PAGE_COUNT: 200,
  ALL_USERS_COUNT: 2000,
  AGGREGATION_FILTER_PER_PAGE: 5,
  BREAKDOWN_DATA: 100,
  SCENARIOS_PER_PAGE_COUNT:100,
  LLM_LOGS_PER_PAGE_COUNT: 100
};
//
export default PAGINATION;
